import laborPricingCompany from "services/offlineComputing/models/laborPricingCompany";

export const getLaborPricing = async (o, q) => {
  const query = { ...q, ...o };

  const laborPricing = await laborPricingCompany.find(query);
  return laborPricing;
};
